export const COLUMNS = [
  {
    header: "Full Name",
    accessor: "full_name",
  },
  {
    header: "Email",
    accessor: "email",
  },
  {
    header: "Package",
    accessor: "EwaPackage",
  },
  {
    header: "Message",
    accessor: "message",
  },
];
